module.exports = __webpack_public_path__ + "img/sistema-indiretto-doppio.279bae94.png";